<template>
  <div class="list-box bg-gray-100 rounded-lg">
    <div
      class="nav gap-x-3"
      title="HuiYiDetailRenYuanList"
      data-title="参会人员"
    >
      <li
        v-if="state.select_count > 0"
        class="text-sm text-gray-400 flex items-center"
      >
        已选
        <strong class="text-orange-600 mx-1">{{ state.select_count }}</strong>
        条数据
        <el-button type="danger" link @click="onClearSelect"> 清空 </el-button>
      </li>
      <el-input
        v-model="state.params.keywords"
        class="c-search-white"
        clearable
        placeholder="关键字"
        @keyup.enter="onLoad()"
        @clear="onLoad()"
      >
        <template #suffix>
          <el-icon
            @click="onLoad()"
            color="#a2a2a2"
            title="搜索"
            class="font-bold cursor-pointer hover:opacity-60"
            ><Search
          /></el-icon>
        </template>
      </el-input>
      <div class="flex items-center" v-if="!props.search">
        <el-button type="primary" icon="Plus" @click="state.showSelect = true">
          添加
        </el-button>
        <el-button
          type="danger"
          icon="Delete"
          @click="onDeletes()"
          :disabled="!state.select_count"
          :title="!state.select_count ? '请先选择要操作的数据' : ''"
        >
          删除
        </el-button>
      </div>
    </div>
    <div class="content c-table-box mt-2 bg-white rounded-lg p-2.5">
      <el-table
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        row-key="id"
        ref="tableDom"
        @sort-change="onSortChange"
        @selection-change="onSelectChange"
        @row-click="onRowClick"
      >
        <el-table-column
          type="selection"
          width="55"
          reserve-selection
          v-if="!props.search"
        />
        <el-table-column
          fixed
          label="#"
          width="70"
          type="index"
          :index="
            (index) =>
              $buildTabIndex(state.params.page, state.params.limit, index)
          "
          align="center"
        />
        <el-table-column :min-width="240">
          <template #header>
            <div class="c-table-col-header" label1="姓名" label2="性别/身份" />
          </template>
          <template #default="{ row }">
            <div class="flex items-center gap-x-1">
              <c_Avatar
                v-if="row.id"
                :file_url="
                  row.meetingAttendee?.conferee?.avatar_attachment?.file_url
                "
                :size="10"
                :title="row.meetingAttendee?.conferee?.name?.slice(0, 1)"
                class="flex-shrink-0"
              />
              <div class="flex-shrink-0 ml-1">
                <ul class="flex items-center gap-x-1">
                  <strong
                    class="text-green-700 cursor-pointer hover:underline"
                    @click.stop="
                      state.selectItem = row;
                      state.showDetail = true;
                    "
                  >
                    {{ row.meetingAttendee?.conferee?.name }}
                  </strong>
                  <text>{{ row.meetingAttendee?.conferee?.pinyin }}</text>
                  <c_sex
                    :value="row.meetingAttendee?.conferee?.sex"
                    v-if="row.meetingAttendee?.conferee?.id"
                  />
                  <c_status
                    v-if="row.meetingAttendee?.id"
                    arrName="Meeting_Attend_Type"
                    :value="row.meetingAttendee?.attend_type"
                    showBg
                    :key="row.meetingAttendee?.attend_type"
                  />
                </ul>
                <div class="flex flex-wrap gap-2">
                  <el-tag
                    type="info"
                    size="small"
                    v-for="item in row.meetingAttendee?.d_conferee_tag_json_arr"
                    :key="item"
                  >
                    {{ item }}
                  </el-tag>
                </div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column :min-width="140">
          <template #header>
            <div
              class="c-table-col-header"
              label1="联系电话"
              label2="邮箱/地址"
            />
          </template>
          <template #default="{ row }">
            <c_tabgroup :value2="row.meetingAttendee?.conferee?.address">
              <template #top>
                <text>{{
                  $phoneFormat(row.meetingAttendee?.conferee?.phone)
                }}</text>
                <text class="text-gray-400 text-xs ml-4">{{
                  row.meetingAttendee?.conferee?.email
                }}</text>
              </template>
            </c_tabgroup>
          </template>
        </el-table-column>
        <el-table-column>
          <template #header>
            <div class="c-table-col-header" label1="单位信息" label2="职位" />
          </template>
          <template #default="{ row }">
            <c_tabgroup
              :value1="row.meetingAttendee?.conferee?.company || '-'"
              :value2="row.meetingAttendee?.conferee?.job"
            />
          </template>
        </el-table-column>
        <el-table-column label="签到状态" align="center">
          <template #default="{ row }">
            <el-icon
              color="#080"
              :size="18"
              v-if="row.meetingAttendeeSchedule?.signup_status == 1"
            >
              <Select />
            </el-icon>
            <el-icon color="#a2a2a2" :size="18" v-else class="rotate-45">
              <Remove />
            </el-icon>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          fixed="right"
          align="center"
          :width="120"
          v-if="!props.search"
        >
          <template #default="{ row }">
            <el-button
              type="danger"
              :icon="Delete"
              link
              @click.stop="onDelete(row)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </div>
  </div>
  <el-dialog
    v-model="state.showSelect"
    :title="'添加参会人-' + props.meeting_schedule_name"
    class="c-el-dialog"
    :before-close="
      () => {
        state.showSelect = false;
      }
    "
    style="height: 80vh"
  >
    <c_select
      :meeting_id="props.meeting_id"
      :meeting_schedule_id="props.meeting_schedule_id"
      @close="
        state.showSelect = false;
        onLoad();
      "
    />
  </el-dialog>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  meeting_attendee_schedule_page,
  meeting_attendee_schedule_delete,
} from "@/http/meeting";
import { onDeleteConfirm } from "@/utils/funcs";
import { ElMessageBox, ElMessage } from "element-plus";

import c_select from "./Select.vue";

class InitFormData {
  params = {
    page: 1,
  };
}

export default {
  props: {
    meeting_id: Number,
    meeting_schedule_id: Number,
    meeting_schedule_name: String,
    search: Boolean,
  },
  components: {
    c_select,
  },
  setup(props) {
    const tableDom = ref(null);
    const state = reactive({
      ...new InitFormData(),
    });
    onMounted(() => {
      state.params.meeting_schedule_id = props.meeting_schedule_id;
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      meeting_attendee_schedule_page(state.params).then((res) => {
        if (res.status == 200) {
          const { list, count } = res.data?.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //删除
    const onDelete = (row) => {
      onDeleteConfirm(
        meeting_attendee_schedule_delete,
        row.id,
        () => {
          onLoad();
          tableDom.value.clearSelection();
        },
        {
          filed: "参会人",
          name: row.meetingAttendee?.conferee?.name,
        },
      );
    };

    //删除
    const onDeletes = (row) => {
      const rows = tableDom.value.getSelectionRows();
      if (rows.length <= 0) {
        ElMessage.warning("请选择要操作的数据！");
        return;
      }

      ElMessageBox.confirm(
        `您确定<strong style='color:var(--el-color-danger)'>删除</strong>已选<strong style='color:#080'>${rows.length}</strong>参会人吗？`,
        "删除确认",
        {
          confirmButtonText: "立即删除",
          cancelButtonText: "取消",
          dangerouslyUseHTMLString: true,
          type: "error",
          customClass: "c-delete-dialog",
          confirmButtonClass: "el-button--danger",
          cancelButtonClass: "is-plain",
        },
      ).then(() => {
        meeting_attendee_schedule_delete(rows.map((m) => m.id).join(",")).then(
          (res) => {
            if (res.status == 200) {
              ElMessageBox.alert(res.data?.msg, "提示", {
                dangerouslyUseHTMLString: true,
                type: "success",
                callback: () => {
                  tableDom.value.clearSelection();
                  onLoad();
                },
              });
            } else {
              ElMessage({
                message: res.data,
                type: "error",
              });
            }
          },
        );
      });
    };

    const onRowClick = (item) => {
      tableDom.value.toggleRowSelection(item);
    };

    //选择项改变事件
    const onSelectChange = (e) => {
      state.select_count = e.length;
    };

    //清空已选
    const onClearSelect = () => {
      tableDom.value.clearSelection();
      state.select_count = 0;
    };

    return {
      state,
      props,
      tableDom,
      onLoad,
      onSelectChange,
      onDelete,
      onClearSelect,
      onRowClick,
      onDeletes,
    };
  },
};
</script>

<style lang="scss" scoped></style>
